export default __webpack_public_path__ + "alberta-wound-bandage-change.4b79ac0a863f9237963b.svg";